import { useEffect, useRef } from "react"

import { useSelector } from "react-redux"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"

export const useBalanceTopUpEvent = () => {
  const { pathname } = useLocation()
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const { userInfo } = useSelector((state) => state.auth)

  const isEventSentRef = useRef(false)

  const clearTransactionParams = () => {
    searchParams.delete("transaction_id")
    searchParams.delete("value")
    searchParams.delete("currency")
    searchParams.delete("item_id")
    searchParams.delete("item_name")
    searchParams.delete("price")
    searchParams.delete("quantity")
    setSearchParams(searchParams)
  }

  useEffect(() => {
    if (
      !isEventSentRef.current &&
      (pathname.includes("balance/thank-you") ||
        pathname.includes("balance") ||
        pathname.includes("dashboard/thank-you") ||
        pathname.includes("onboarding/top-up"))
    ) {
      const transaction_id = searchParams.get("transaction_id")
      const value = searchParams.get("value")
      const currency = searchParams.get("currency")
      const item_id = searchParams.get("item_id")
      const item_name = searchParams.get("item_name")
      const price = searchParams.get("price")
      const quantity = searchParams.get("quantity")

      if (
        transaction_id &&
        value &&
        currency &&
        item_id &&
        item_name &&
        price &&
        quantity &&
        userInfo
      ) {
        window.dataLayer?.push({
          event: "purchase",
          ecommerce: {
            transaction_id,
            value: parseFloat(value),
            currency,
            items: [
              {
                item_id,
                item_name,
                price: parseFloat(price),
                quantity: parseInt(quantity)
              }
            ]
          },
          user_data: {
            user_id: userInfo?.id,
            email: userInfo?.email
          }
        })

        isEventSentRef.current = true
        const newPathname = pathname.replace("/thank-you", "")
        clearTransactionParams()
        if (pathname.includes("/thank-you")) {
          navigate(newPathname)
        }
      }
    }
  }, [pathname, searchParams, navigate, userInfo])

  return null
}
